/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Planned, 1 = InProgress, 2 = Completed, 3 = Cancelled
 */
export enum ComponentOrderStatus {
    Planned = 0,
    InProgress = 1,
    Completed = 2,
    Cancelled = 3
}

